import React, { Children, cloneElement } from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { createLucideIcon } from "lucide-react";
import TagWrapper from './TagWrapper';
import Icon from './Icon';

export const BreadcrumbItem = ({
	children,
	ariaLabel,
	className,
	tag = 'li',
	to,
	isActive,
	divider,
	...rest
}) => {
	return (
		<TagWrapper
			tag={tag}
			className={classNames('breadcrumb-item', { active: isActive }, className)}
			aria-current={isActive ? 'page' : null}
			aria-label={ariaLabel || children}
			{...rest}>
			{divider &&
				typeof divider !== 'string' &&
				cloneElement(divider, {
					className: classNames('breadcrumb-icon', divider.props.className),
				})}
			{isActive ? (
				children
			) : (
				<NavLink to={to} aria-label={ariaLabel}>
					{children}
				</NavLink>
			)}
		</TagWrapper>
	);
};

const Breadcrumb = ({
	children,
	list,
	tag = 'nav',
	listTag = 'ol',
	itemTag = 'li',
	ariaLabel = 'breadcrumb',
	autoActive = true,
	isToHome = <Icon iconName='Home' width="19" height="19" />,
	divider = <Icon iconName='ChevronRight' width="13" height="13" />,
	...rest
}) => {
	const DIVIDER = divider !== 'string' && divider;
	return (
		<TagWrapper
			tag={tag}
			aria-label={ariaLabel}
			style={
				divider
					? {
							'--bs-breadcrumb-divider':
								typeof divider === 'string' ? `'${divider}'` : 'none',
						}
					: null
			}
			{...rest}>
			<TagWrapper tag={listTag} className='breadcrumb'>
				{isToHome && (
					<BreadcrumbItem to='/' ariaLabel='Home'>
						{isToHome}
					</BreadcrumbItem>
				)}
				{list
					? list.map((item, index) => (
							<BreadcrumbItem
								key={item.title}
								tag={item.tag || itemTag}
								to={item.to}
								isActive={autoActive && list.length === index + 1}
								divider={DIVIDER}>
								{item.title}
							</BreadcrumbItem>
						))
					: Children.map(children, (child, index) =>
							cloneElement(child, {
								tag: child.props.tag || itemTag,
								isActive: autoActive && children.length === index + 1,
								divider: child.props.divider || DIVIDER,
							}),
						)}
			</TagWrapper>
		</TagWrapper>
	);
};

export default Breadcrumb;
